module.exports = __webpack_public_path__ + "img/ring_g_e_null_1.cdac5061.png";